import { Button, Input } from '@sainsburys-tech/fable'
import { Add, Minus } from '@sainsburys-tech/icons'
import React, { useEffect, useState } from 'react'

interface IProps {
  id: number
  step: number
  value: number
  setValue: (skuId: number, value: number) => void
}

const Incrementor = (props: IProps) => {
  const isMinusDisabled = () => props.value === 0
  const isPlusDisabled = () => props.value >= 999

  const [draft, setDraft] = useState(props.value.toString())

  useEffect(() => {
    setDraft(props.value.toString())
  }, [props.value])

  const handleChange = (value: string) => {
    if (value === '' || /^\d{0,3}$/.test(value)) {
      setDraft(value)
    }
  }

  const commit = () => {
    const finalVal = draft === '' ? 0 : parseInt(draft, 10)
    if (!isNaN(finalVal) && finalVal !== props.value) {
      props.setValue(props.id, finalVal)
    }
    setDraft(finalVal.toString())
  }

  const applyStep = (delta: number) => {
    const next = Math.min(Math.max(props.value + delta, 0), 999)
    props.setValue(props.id, next)
    setDraft(next.toString())
  }

  return (
    <div className='c-common-incrementor'>
      <div className='c-common-incrementor__button c-batch-card-no-left-padding c-batch-table-incrementor-button'>
        <Button
          aria-label='Decrement'
          disabled={isMinusDisabled()}
          onClick={() => applyStep(-props.step)}
          icon={<Minus />}
          variant={'secondary'}
          testid='minus-button'
          style={{ backgroundColor: 'transparent' }}
        />
      </div>
      <div className='c-common-incrementor__input-text-box'>
        <Input
          id={`incrementor-${props.id}`}
          label={`Quantity for SKU ${props.id}`}
          hasHiddenLabel
          name={`actualProductionInput-${props.id}`}
          autocomplete='off'
          type='text'
          inputMode='numeric'
          pattern='[0-9]*'
          onBlur={commit}
          onChange={(value) => handleChange(value)}
          value={draft}
          testid='hotfood-incrementor-input'
        />
      </div>
      <div className='c-common-incrementor__button c-batch-table-incrementor-button'>
        <Button
          aria-label='Increment'
          disabled={isPlusDisabled()}
          onClick={() => applyStep(props.step)}
          icon={<Add />}
          testid='plus-button'
          variant={'secondary'}
          style={{ backgroundColor: 'transparent' }}
        />
      </div>
    </div>
  )
}

export default Incrementor
